import { computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';

// Abas do Painel geral. Area trancada (modulo fora da conta) nao vira aba:
// aparece so como card de ativar na Visao geral. A aba escolhida fica na URL
// (?aba=), entao sobrevive ao F5 e pode ser compartilhada.
export const PANEL_TABS = [
  { key: 'geral', area: null },
  { key: 'negocios', area: 'deals' },
  { key: 'atendimento', area: 'service' },
  { key: 'atividades', area: 'activities' },
];

const isOpen = state => !!state && state !== 'locked';

export const visibleTabs = (modules = {}) =>
  PANEL_TABS.filter(tab => !tab.area || isOpen(modules[tab.area]));

export const lockedAreas = (modules = {}) =>
  PANEL_TABS.filter(tab => tab.area && modules[tab.area] === 'locked').map(
    tab => tab.area
  );

export function usePanelTabs(modules) {
  const route = useRoute();
  const router = useRouter();

  const tabs = computed(() => visibleTabs(modules.value || {}));
  const activeKey = computed(() =>
    tabs.value.some(tab => tab.key === route.query.aba)
      ? route.query.aba
      : 'geral'
  );
  const setTab = key => router.replace({ query: { ...route.query, aba: key } });

  return { tabs, activeKey, setTab };
}
